<!--
    描述：虚拟组织架构
    时间：2020-04-26
    Created by yefan
-->
<template>
	<div class="h100">
		<div class="w-page-main">
			<div class="w-page-header superiors-search-area">
				<div class="left-text overflow-hidden">
					<span><b>虚拟组织架构</b></span>
				</div>
				<div class="btnGroups ml10">
					<el-button type="primary"
							   size="small"
                               v-if="roleBtns.includes('virtual_add')"
							   @click="doClick('add',{})">新增
					</el-button>
				</div>
			</div>
			<div class="w-page-container pdb10">
				<div class="w-table-layout">
					<div class="w-table-content"
						 ref="deptsContent">
						<el-table ref="virtualDeptsTree"
								  row-key="id"
								  :data="virtualDeptStructure.tableData"
								  v-loading="virtualDeptStructure.loading"
								  :expand-row-keys="virtualDeptStructure.expandKeys"
								  :height="virtualDeptStructure.tableH"
								  border
								  highlight-current-row
								  @row-click="rowClick"
								  :tree-props="{children: 'children'}">
							<el-table-column type="index"
											 align="center"
											 width="50"></el-table-column>
							<el-table-column header-align="center"
											 prop="sname"
											 label="虚拟组织名称"
											 show-overflow-tooltip
											 min-width="150"></el-table-column>
							<el-table-column label="操作"
											 align="center"
											 show-overflow-tooltip
											 width="120">
								<template slot-scope="scope">
									<el-button size="mini"
											   icon="el-icon-circle-plus-outline"
											   title="新增"
                                               v-if="roleBtns.includes('virtual_add')"
											   type="text"
											   @click="doClick('add', scope.row)"></el-button>
									<el-button size="mini"
											   icon="el-icon-edit"
											   title="编辑"
                                               v-if="roleBtns.includes('virtual_edit')"
											   type="text"
											   @click="doClick('edit', scope.row)"></el-button>
									<el-button size="mini"
											   icon="el-icon-search"
											   title="查看"
                                               v-if="roleBtns.includes('virtual_view')"
											   type="text"
											   @click="doClick('view', scope.row)"></el-button>
									<el-button size="mini"
											   icon="el-icon-delete"
											   title="删除"
											   type="text"
											   v-if="!scope.row.children && roleBtns.includes('virtual_delete')"
											   @click="doClick('delete', scope.row)"></el-button>

									<!-- <el-dropdown @command="doClick($event,scope.row)">
                                        <span class="el-dropdown-link"><i class="el-icon-more"></i></span>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item command="add">新增</el-dropdown-item>
                                            <el-dropdown-item command="edit">编辑</el-dropdown-item>
                                            <el-dropdown-item command="view">查看</el-dropdown-item>
                                            <el-dropdown-item v-if="!scope.row.children" command="delete">删除
                                            </el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown> -->
								</template>
							</el-table-column>
						</el-table>
					</div>
				</div>
			</div>
		</div>
		<!-- 新增、编辑等弹窗 -->
		<el-dialog :title="dialogObj.title"
				   :visible.sync="dialogObj.visible"
				   :width="dialogObj.width"
				   :close-on-click-modal="false"
				   destroy-on-close>
			<!-- 弹窗组件 -->
			<addVirtualDept ref="addVirtualDept"
							:virtualDeptInfo="virtualDeptInfo"
							:mode="dialogObj.mode"
							v-if="dialogObj.visible"
							@dialogClose="handleClose"></addVirtualDept>
			<!-- footer 组件 -->
			<div slot="footer"
				 class="dialog-footer text-center"
				 v-if="dialogObj.mode !== 'view'">
				<el-button size="small"
						   @click="dialogObj.visible = false">取 消</el-button>
				<el-button type="primary"
						   size="small"
						   :loading="btnLoading"
						   @click="doSave">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import { mapState } from 'vuex'
import { getVirtualDeptTree, removeVirtualDept } from '@/api/modules/group.js'
import addVirtualDept from './add_virtual_dept_dialog'

export default {
	components: { addVirtualDept },
	data() {
		return {
			virtualDeptStructure: {
				loading: false,
				tableH: 200,
				tableData: [],
				expandKeys: []
			},
			dialogObj: {
				title: '添加虚拟组织',
				visible: false,
				width: '400px',
				mode: 'add'
			},
			virtualDeptInfo: { id: '0', sname: '', groupId: '' },
			btnLoading: false
		}
	},

	methods: {
		// 初始获取数据
		getVirtualDeptStructure(groupId) {
			this.virtualDeptInfo.groupId = groupId
			let param = {}
			param.groupId = groupId
			getVirtualDeptTree(param).then(res => {
				this.virtualDeptStructure.tableData = res.data
				if (res.data.length > 0) {
					this.virtualDeptStructure.expandKeys.push(
						res.data[0].id.toString()
					)
					/*                        this.$refs.virtualDeptsTree.setCurrentRow(res.data[0]);
                        this.rowClick(res.data[0]);*/
				}
			})
		},

		// 关闭弹窗事件
		handleClose() {
			this.dialogObj.visible = false
			this.getVirtualDeptStructure(this.virtualDeptInfo.groupId)
		},

		// 确定按钮事件
		doSave() {
			this.$refs.addVirtualDept.doSave()
		},

		// 删除
		doDelete(row) {
			this.$confirm('确认删除吗?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				let param = {}
				param.id = row.id
				removeVirtualDept(param).then(res => {
					res.code === 0
						? this.$message.success('删除成功！')
						: this.$message.error(res.msg)
					this.getVirtualDeptStructure(this.virtualDeptInfo.groupId)
				})
			})
		},

		//操作按钮事件
		doClick(type, row) {
			let groupId = this.virtualDeptInfo.groupId
			this.virtualDeptInfo = row
			if (type === 'delete') {
				this.doDelete(row)
			} else {
				this.dialogObj.visible = true
				this.dialogObj.mode = type
				if (type === 'add') {
					this.virtualDeptInfo.groupId = groupId
					this.dialogObj.title = '添加虚拟组织'
				} else if (type === 'edit') {
					this.dialogObj.title = '编辑虚拟组织'
				} else if (type === 'view') {
					this.dialogObj.title = '查看虚拟组织'
				}
			}
		},

		//行点击事件
		rowClick(row) {
			this.$emit('virtualDeptRowClick', row)
		}
	},

	mounted() {
		this.$nextTick(() => {
			setTimeout(() => {
				this.virtualDeptStructure.tableH = this.$refs.deptsContent.offsetHeight
			}, 100)
		})
	},

	// 进入缓存页面
	activated() {
		this.$nextTick(() => {
			setTimeout(() => {
				this.virtualDeptStructure.tableH = this.$refs.deptsContent.offsetHeight
			}, 100)
		})
	},

	computed: {
		...mapState('app', { clientSize: state => state.clientSize }),
		...mapState('menu', {
			roleBtns: state => state.roleBtns
		})
	},

	watch: {
		clientSize(val) {
			this.virtualDeptStructure.tableH = this.$refs.deptsContent.offsetHeight
		}
	}
}
</script>
<style lang="less"></style>
